export const BREAKPOINTS = {
  'breakpoint-mobile': 767,
  'breakpoint-tablet': 768,
  'breakpoint-tablet-s': 768,
  'breakpoint-tablet-l': 1024,
  'breakpoint-desktop': 1280,
  'breakpoint-desktop-s': 1280,
  'breakpoint-desktop-m': 1366,
  'breakpoint-desktop-l': 1440,
} as const;
